import React from 'react';

import { IconButton } from '@/components/ui';

type EditButtonProps = {
	/**
	 * Callback function to execute when edit button is pressed
	 */
	onPress: () => void;

	/**
	 * Size of the edit icon
	 */
	size?: number;

	/**
	 * Additional styles to apply to the button
	 */
	style?: any;

	/**
	 * Icon to use (defaults to 'pencil')
	 */
	icon?: string;

	/**
	 * Whether the button is disabled
	 */
	disabled?: boolean;

	/**
	 * Custom color for the icon (defaults to theme.colors.primary)
	 */
	iconColor?: string;

	testID?: string;
};

export const EditButton: React.FC<EditButtonProps> = ({
	onPress,
	size = 16,
	style = { margin: 0 },
	icon = 'pencil',
	disabled = false,
	iconColor,
	testID,
}) => {
	return (
		<IconButton
			icon={icon}
			size={size}
			style={style}
			iconColor={iconColor}
			onPress={onPress}
			disabled={disabled}
			testID={testID}
		/>
	);
};
